
const prodConfig = {
  apiKey: "AIzaSyDaQ3OKcTozNx9m8UQK3z_djtx9QwwQN3g",
  authDomain: "colorribbon-61660.firebaseapp.com",
  databaseURL: "https://colorribbon-61660.firebaseio.com",
  projectId: "colorribbon-61660",
  storageBucket: "colorribbon-61660.appspot.com",
  messagingSenderId: "625620632627"
}

const devConfig = {
  apiKey: "AIzaSyDsTVwqwLuH3VgwirssLcjuNdgEmILTslo",
  authDomain: "colorribbon-dev.firebaseapp.com",
  databaseURL: "https://colorribbon-dev.firebaseio.com",
  projectId: "colorribbon-dev",
  storageBucket: "colorribbon-dev.appspot.com",
  messagingSenderId: "468666632919"
}

const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig

export default config



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/firebase/config.js